import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventLabel, GaTrackingEventName, GATrackingEventType} from '../../constants';
import { ApplicationSearchInteractionType } from '~shared/modules/application-event/constants';

export class GATrackingSearchInteractionEvent implements GATrackingEvent {

  constructor(private type: ApplicationSearchInteractionType) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SearchInteraction;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.SearchBarInteraction,
      label: this.getLabel()
    };
  }

  private getLabel(): string | null {
    switch (this.type) {
      case ApplicationSearchInteractionType.BounceOfSearchBar:
        return GaTrackingEventLabel.BounceOfBar;
      case ApplicationSearchInteractionType.ClickInTheSearchBar:
        return GaTrackingEventLabel.ClickInTheBar;
      default:
        console.warn('Unknown application search interaction type --> ', this.type);
        return null;
    }
  }
}
